module.exports = __webpack_public_path__ + "static/media/js-logo.011e11c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/js-logo.png
// module id = 37
// module chunks = 0